module.exports = "<div class=\"pp-overlay pp-gameplay-level-intro-overlay\" data-bind=\"visible: overrideVisibility\">\n\n    <div class=\"pp-overlay__background twenty-percent\"></div>\n\n    <div class=\"pp-overlay__modal pp-overlay__modal__auto-size\">\n\n        <p class=\"pp-gameplay-level-intro-overlay__title\" data-bind=\"text: levelText\"></p>\n        <p class=\"pp-gameplay-level-intro-overlay__super-title\">Get ready!</p>\n\n    </div>\n\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/ts/screens/gameplay/level-intro/LevelIntroScreen.html
// module id = 64
// module chunks = 0